module.exports = __webpack_public_path__ + "static/media/img16.6be78d99.jpg";